import { IMAGES } from "./images";

// Instagram feed — SIMULATED. See services/contentService.getInstagramFeed().
// FUTURE INTEGRATION: replace with Instagram Graph API media endpoint.
export const INSTAGRAM_POSTS = [
  { id: "ig1", image: IMAGES.ig1, span: "md:col-span-2 md:row-span-2", altEn: "Floral installation at a luxury wedding" },
  { id: "ig2", image: IMAGES.ig2, span: "", altEn: "Macro of a premium rose" },
  { id: "ig3", image: IMAGES.ig3, span: "", altEn: "Ranunculus in an editorial arrangement" },
  { id: "ig4", image: IMAGES.ig4, span: "", altEn: "Floral designer at work" },
  { id: "ig5", image: IMAGES.ig5, span: "", altEn: "Wedding ceremony florals" },
  { id: "ig6", image: IMAGES.ig6, span: "md:col-span-2", altEn: "Export packing of fresh flowers" },
];
